import { AccredibleAccountsRedirectionService } from '@accredible-frontend-v2/services/accounts-redirection';
import { Component } from '@angular/core';
import { ThemeHelper } from '@spotlight/domain';

@Component({
  templateUrl: './footer.component.html',
  styleUrls: [`./footer.component.scss`],
})
export class FooterComponent {
  readonly themeName = ThemeHelper.getTheme();
  retrieveCredentialsUrl = this._accountsRedirection.getRetrieveCredentialsUrl();
  isUserSignedIn = false;

  constructor(private readonly _accountsRedirection: AccredibleAccountsRedirectionService) {}
}
